import React from "react";
import './KindWords.css';
import { Carousel } from 'react-responsive-carousel';
import {renderThumbs, renderIndicators, renderArrowPrev, renderArrowNext} from '../../commons/carousel.js'
import { AnimationOnScroll } from 'react-animation-on-scroll';

export default class KindWords extends React.Component {

	renderCarousel(itemsPerSlide){

		const CONTENT=[
			{username:"Kaisen#9357", review:"I love how the project linked its reinvention of rarity with diversity, and considering the evolution at which female and LGBTQ+ NFT community is steadily matching the presence of its male counterpart in the NFT space (I would daresay even overtaking, in some cases), this initiative from the team is even more relevant in today's NFT landscape."},
			{username:"Jerseybug", review:"Great to hear. Giving the community, the people who know the projects, the ability to decide the rankings or rarity is good news. But also spreading the message and letting other projects to come on board is what builds a stronger and larger nft community. Great idea."},
			{username:"Traves", review:"This is so refreshing to see! Finally a rating system that is not just based on numbers, but actually values what the artist considers to be the most important features of their work. I've always though that some of the best pieces in many collections were the lowest rated."},
			{username:"TribeX", review:"To show our gratitude and appreciation to our new frenz over at @WallStFam / We'd like to return the favor and give your community  10 free-to-mint #iamtribex NFTs and also this honorary. From one community to another this is \"THE POWER OF US\" #StrongerTogether "},
			{username:"Diehard812", review:"Been here since the beginning. Out of so many projects I am in, this one is non stop working on elevating and doing great things that nobody else is. Time to get bullish."},
			{username:"FreaksNGuilds", review:"We've been feeling extra Freaky lately and have decided to switch to start using Viberater.io VibeRater solves many of the issues we faced using current rarity yools in the marketplace. With VibeRater both creatores and degens can find pleasure in researching NFTs."},
			{username:"RagnarTargaryen", review:"We appreciate your willingness to help, your transparent assessment, and for providing the test suite for us to validate and help us provide a valuable educational opportunity!"},
			{username:"Rxsmitty", review:"This is becoming more and more important as teams develop new ways beyond creating traits, reviewing matches, and then pushing P to create a collection of 10K. Many are moving to creating a collection of 100K and then hand curating 10K, which will provide value and uniqueness to collections that aren't accounted for in the current rarity setting. I wish more projects would adopt this methodology, there are very few collections out there innovating!"},
			{username:"Leon Rodriguez", review:"I think the work they are doing is very important. They are creating something new and unique and I think it is very necessary because we are at a time when everyone is doing the same thing in order to earn money. You have to know how to differentiate between projects that add value and this is one of them, That's why I love this project and I will support it until the end."},
		]
		let slideContent=[]
		for (let i = 0; i < CONTENT.length; i += itemsPerSlide) {
			let chunk = CONTENT.slice(i, i + itemsPerSlide);
			slideContent.push(chunk)
		}
		return <Carousel
			renderArrowPrev={renderArrowPrev}
			renderArrowNext={renderArrowNext}
			renderThumbs={renderThumbs}
			renderIndicator={renderIndicators}
			showStatus={false}>
			{slideContent.map((c, i)=>{
				return <div className="review-group" key={"group"+i}>
					{c.map((review, j) =>{
						return <div className="review-item" key={"review"+j}>
							<p className="review-text quote-text">{review.review}</p>
							<p className="review-user quote-text">- {review.username}</p>
						</div>
					})}
				</div>
			})}
		</Carousel>
	}

	render() {
		return (
		<div id="kind-words" className="kind-words-container">
			<AnimationOnScroll initiallyVisible={false} animateIn="fadeDown" animateOnce={true} delay={0}>
				<div className="section-briefing">
					<h1 className="section-title">KIND WORDS</h1>
					<div className="briefing-text"></div>
				</div>
			</AnimationOnScroll>
			<AnimationOnScroll initiallyVisible={false} animateIn="fadeUp" animateOnce={true} delay={0}>
				<div className="quote-container overflow-left-margin overflow-right-margin">
					<AnimationOnScroll initiallyVisible={false} animateIn="fadeInAnimation" animateOnce={true} delay={300}>
						<div className="carousel-container slide-3">
							{this.renderCarousel(3)}
						</div>
						<div className="carousel-container slide-2">
							{this.renderCarousel(2)}
						</div>
						<div className="carousel-container slide-1">
							{this.renderCarousel(1)}
						</div>
					</AnimationOnScroll>
				</div>
			</AnimationOnScroll>
		</div>
		);
	}

	openModal(){
		this.setState({isMenuOpen:true})
	}
}
